<template>
    <modal width="50" title="Who is the new package for?" :show-modal="showModal" @close-modal="$emit('closeModal')">
        <div class="delete-modal">

            <div class="opt_container">
                <div class="w-full flex mt-1 gap-4 justify-end flex-wrap">
                    <label :for="'recieverSame'" class="radio-label">
                        <input class="bg-primary-yellow text-secondary-yellow" :name="'reciever'" type="radio"
                            :id="'recieverSame'" value="same" v-model="reciever" />
                        Same Receiver
                        <span></span>
                    </label>

                    <div class="reciever_detail" v-if="reciever === 'same'">
                        <p class="reciever_info_wrapper">
                            <b class="headers">Name:</b>
                            <span>{{ currentReciever.name || '' }}</span>
                        </p>
                        <p class="reciever_info_wrapper">
                            <b class="headers">Contact Person:</b>
                            <span>{{ currentReciever.contactName || '' }}</span>
                        </p>
                        <p class="reciever_info_wrapper">
                            <b class="headers">Destination Address:</b>
                            <span>{{ currentReciever.address && currentReciever.address.name ? currentReciever.address.name : '' }}</span>
                        </p>
                        <p class="reciever_info_wrapper">
                            <b class="headers">Phone Number:</b>
                            <span>{{ currentReciever.mobile || '' }}</span>
                        </p>
                        <p class="reciever_info_wrapper">
                            <b class="headers">Email Address:</b>
                            <span>{{ currentReciever.email || '' }}</span>
                        </p>
                    </div>

                    <label :for="'recieverDiff'" class="radio-label">
                        <input type="radio" v-model="reciever" value="different" :id="'recieverDiff'"
                            :name="'reciever'" />
                        Different Receiver
                        <span></span>
                    </label>

                    <div v-if="addNewReciever !== true && reciever === 'different'" class="reciever_select">
                        <div class="slice-option">
                            <label class="label">Receiver
                                <base-checkbox v-model="addNewReciever" label="Add New Receiver" />
                            </label>
                            <el-select filterable v-model="selecetedReciever" placeholder="Select">
                                <el-option v-for="(reciever, index) in recieversList" :key="index + 'receiver'"
                                    :label="reciever.name || reciever.contactName || ''" :value="`${reciever?.email}-${reciever?.name || reciever?.contactName || ''}`"></el-option>
                            </el-select>
                        </div>
                    </div>

                    <div class="w-full" v-if="addNewReciever == true && reciever !== 'same'">
                        <div class="w-full flex mt-1 gap-4 justify-start">
                            <label for="recieverBusiness" class="radio-label">
                                <input class=" bg-primary-yellow text-secondary-yellow" name="recievertype" type="radio"
                                    id="recieverBusiness" value="business" v-model="newReciever.type" />
                                Business Customer
                                <span></span>
                            </label>

                            <label for="recieverPrivate" class="radio-label">
                                <input type="radio" v-model="newReciever.type" value="private" id="recieverPrivate"
                                    name="recievertype" />
                                Private Customer
                                <span></span>
                            </label>
                        </div>

                        <div class="slice-option">
                            <label class="label">Name</label>
                            <input type="text" class="input-mini" placeholder="--Enter--" v-model="newReciever.name" />
                        </div>
                        <div v-if="newReciever.type === 'business'" class="slice-option">
                            <label class="label">Contact Person</label>
                            <input type="text" class="input-mini" placeholder="--Enter--"
                                v-model="newReciever.contactName" />
                        </div>
                        <div class="slice-option">
                            <label class="label">Email</label>
                            <input type="text" class="input-mini" placeholder="--Enter--" v-model="newReciever.email" />
                        </div>

                        <div class="slice-option_phone">
                            <div class="flex justify-between items-center">
                                <label class="label whitespace-no-wrap">Phone Number</label>
                            </div>
                            <vue-tel-input v-model="newReciever.mobile" class="phone_input_style"></vue-tel-input>
                            <span v-if="isPhoneNumberInValid" class="mt-2 text-red-500 inline-block">Phone number is
                                invalid</span>
                        </div>

                        <div class="slice-option">
                            <div class="flex justify-between items-center">
                                <label class="label whitespace-no-wrap">Address</label>
                            </div>
                            <!-- <auto-complete :customStyle="customStyle" :locationDetails="viewLocationDetails"
                                placeholder="Enter Address" :value="newReciever.address.name" /> -->
                            <input v-model="addressInput" type="text" class="input-mini" placeholder="--Enter--" />
                            <span v-if="newReciever.address?.name && addressInput != ''" class="google_pick_location">
                                <img src="/icons/location_icon.svg" class="image_loc" />
                                {{ selectedAddress ? selectedAddress.name : "" }}</span>
                        </div>

                        <div class="slice-option_picker">
                            <div class="flex justify-between items-center flex-wrap w-full mt-4">
                                <label class="label">Preferred Pickup Time Range</label>
                                <div class="flex  w-full justify-between items-center mt-1">
                                    <!-- <div class="clock_box">
                            <img src="./icons//clock.svg"/>
                        </div> -->
                                    <el-time-picker class="full_width full_width_sender mr-2 only_hour_picker"
                                        placeholder="Start time" v-model="startTime" :disabled-seconds="true"
                                        format="hh:mm" value-format="hh" popper-class="only_hour_picker">
                                    </el-time-picker>
                                    <el-time-picker class="full_width full_width_sender" placeholder="End time"
                                        v-model="endTime" popper-class="only_hour_picker" :disabled-seconds="true"
                                        format="hh:mm" value-format="hh">
                                    </el-time-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div class="flex justify-end mt-8">
                <button class="cancel_btn" @click="closeModal()">Cancel</button>
                <base-button @click="submit" text="Next" />
            </div>
        </div>
    </modal>
</template>

<script>
import moment from "moment";

export default {
    props: {
        showModal: {
            type: Boolean,
            required: true,
            default: false,
        },
        activeReciever: {
            type: Number
        }
    },
    data() {
        return {
            reciever: 'same',
            // currentReciever: {},
            addressInput: "",
            selectedAddress: {},
            selecetedReciever: '',
            addNewReciever: false,
            startTime: "",
            endTime: "",
            newReciever: {
                type: 'private',
                contactName: '',
                name: "",
                email: '',
                mobileNumberType: 'mobile',
                addressType: 'residential',
                address: {},
                mobile: '',
                isEdit: false,
                sendShippingUpdates: false,
                nameSelect: '',
                pickUpTime: [],
            }
        }
    },
    computed: {
        isPhoneNumberInValid() {
            let trimTel = this.newReciever.mobile.replace(/ /g, "")
            return (this.newReciever.mobile != "" && trimTel.length < 11) || (this.newReciever.mobile != "" && trimTel.length > 11)
        },
        customStyle() {
            return {
                width: '100%',
                padding: '7px 10px',
                borderRadius: '5px',
                border: '1px solid rgb(183 189 205)'
            }
        },
        allReciever() {
            return this.$store.getters.getSavedNewRecieverPackage
        },
        recieversList() {
            return this.$store.getters.getSavedNewRecievers
        },
        currentReciever() {
            return this.$store.getters.getSavedNewRecieverPackage[this.activeReciever]
        }
    },
    watch: {
        addressInput(val) {
            if (val.trim().length > 7) {
                this.getCloseLocation(val)
            }
        },
        showModal(val) {
            if (val) {
                //   this.currentReciever = this.$store.getters.getSavedNewRecieverPackage[this.activeReciever]
            }
        }
    },
    methods: {
        async getCloseLocation(val) {
            const res = await this.$_searchAddress({ query: val.trim() })
            this.selectedAddress = res.data.results[0];
            this.newReciever.address = { ...res.data.results[0], name: this.addressInput };
        },
        viewLocationDetails(response) {
            const addressData = {
                name: response?.formatted_address,
                lat: response.geometry?.location.lat(),
                lng: response.geometry?.location.lng(),
                state: response?.address_components?.find(component => component.types.includes("administrative_area_level_1"))?.long_name || '',
            }
            this.newReciever.address = addressData
        },
        closeModal() {
            this.$emit("closeModal");
        },
        getUserIndex(identity) {
            return this.recieversList.findIndex((reciever) => `${reciever?.email}-${reciever?.name || reciever?.contactName || ''}` === identity)
        },
        resetReciever() {
            this.newReciever = {
                type: 'private',
                contactName: '',
                name: "",
                email: '',
                mobileNumberType: 'mobile',
                addressType: 'residential',
                address: {},
                mobile: '',
                isEdit: false,
                sendShippingUpdates: false,
                nameSelect: '',
                package: undefined,
                pickUpTime: [],
            }
        },
        submit() {
            if (this.reciever === 'different' && !this.addNewReciever) {
                this.$emit('setActiveUser', this.getUserIndex(this.selecetedReciever))
                let addAnotherPackages = {
                    ...this.recieversList[this.getUserIndex(this.selecetedReciever)],
                    package: {
                        shipmentType: 'Light',
                        shipmentCategory: '',
                        description: '',
                        estimatedWeight: '',
                        quantity: '',
                        itemValue: '',
                        id: undefined,
                        isSpecialHandling: 'no',
                        specialHandling: '',
                        unitOfWeight: 'kg',
                        deliveryNote: '',
                        packageImages: []
                    }
                }
                const allRecieverPackages = [...this.$store.getters.getSavedNewRecieverPackage, addAnotherPackages];
                this.$store.dispatch('setSavedNewRecieverPackages', allRecieverPackages)
                this.closeModal()
            } else if (this.reciever === 'different' && this.addNewReciever) {
                const { mobile, name = null, email } = this.newReciever
                if (mobile && name && email) {
                    const recieverWithpachkage = {
                        ...this.newReciever,
                        package: {
                            shipmentType: 'Light',
                            shipmentCategory: '',
                            description: '',
                            estimatedWeight: '',
                            quantity: '',
                            itemValue: '',
                            id: undefined,
                            isSpecialHandling: 'no',
                            specialHandling: '',
                            unitOfWeight: 'kg',
                            deliveryNote: ''
                        }
                    }
                    const starttime = this.startTime ? moment(this.startTime, 'h A').format('HH:mm') : undefined;
                    const endtime = this.endTime ? moment(this.endTime, 'h A').format('HH:mm') : undefined;
                    let pickUpTime = starttime && endtime ? [starttime, endtime] : [];

                    this.$store.dispatch('setSavedNewRecievers', [...this.allReciever, { ...this.newReciever, pickUpTime }])
                    const allRecieverPackages = [...this.$store.getters.getSavedNewRecieverPackage, recieverWithpachkage]
                    this.$store.dispatch('setSavedNewRecieverPackages', allRecieverPackages)
                    this.resetReciever()
                    this.addNewReciever = false
                    this.$emit('setActiveUser', Number(this.activeReciever) + 1)
                    this.closeModal()
                }
            } else if (this.reciever === 'same') {
                let addAnotherPackages = {
                    ...this.currentReciever,
                    package: {
                        shipmentType: 'Light',
                        shipmentCategory: '',
                        description: '',
                        estimatedWeight: '',
                        quantity: '',
                        itemValue: '',
                        id: undefined,
                        isSpecialHandling: 'no',
                        specialHandling: '',
                        unitOfWeight: 'kg',
                        deliveryNote: ''
                    }
                }
                this.$store.dispatch('setSavedNewRecieverPackages', [...this.$store.getters.getSavedNewRecieverPackage, addAnotherPackages])
                this.$emit('setActiveUser', Number(this.activeReciever) + 1)
                this.closeModal()
            }
        }
    }
};
</script>

<style scoped>
.full_width {
    width: 100%;
    @apply bg-primary-lightgrey;
}
.slice-option_picker {
    @apply mt-4 sm:mt-8 sm:w-[48%] lg:w-[32%] w-full mr-[2%] lg:mr-[1.333%];
}

.address_grey {
    @apply opacity-50
}

.google_pick_location {
    @apply mt-2 inline-flex ml-2 text-sm items-center opacity-60 w-full;

    img {
        @apply mr-1
    }
}

.image_loc {
    @apply mr-2 w-[17px] opacity-50 mt-[2px]
}

.reciever_info_wrapper {
    @apply text-sm opacity-60 mb-3;
}

.headers {
    @apply block w-full font-semibold text-xs uppercase;
}

.reciever_detail {
    @apply w-full block text-left bg-primary-lightgrey p-3 rounded-lg;
}

.reciever_select {
    @apply w-full block text-left rounded-lg;
}

.cancel_btn {
    @apply py-1 bg-transparent mx-5 text-black-default;
}

.opt_container {
    @apply min-h-[300px] mt-3;
}

.delete-modal {
    text-align: center;
}

.radio-label span::after {
    @apply bg-secondary-yellow
}

.radio-label {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 0.25rem;
}

.label {
    @apply justify-between flex items-center w-full mb-0;
}

.slice-option {
    @apply mt-3 sm:mt-7 w-full mr-[2%] lg:mr-[1.333%];
}

.slice-option_picker {
    @apply mt-3 w-full mr-[2%] lg:mr-[1.333%];
}

.input-mini {
    @apply w-full py-2 px-2 border-[1px] border-primary-palegrey rounded-md bg-primary-lightblue;
}

.slice-option_phone {
    @apply mt-3 sm:mt-6 w-full mr-[2%] lg:mr-[1.333%];
}
</style>